<template>
    <div class="services">
        <div class="addSeviceBtn">
            <button type="button" class="btn btn-add" @click="resetForm2">Add new catalog</button>
        </div>

        <div class="rowInputs" v-if="showServiceForm">
            <div class="form-group">
                <label>Catalogue name:</label>
                <div>
                    <input type="text" placeholder="Entrez le nom du service" class="form-control" v-model="name" :disabled="showWatchServiceForm">
                </div>
            </div>
            <div class="form-group">
                <label>Catalogue file:</label>
                <div>
                    <input type="file" class="form-control" @change="setImage" :disabled="showWatchServiceForm">
                </div>
            </div>
        </div>

        <button type="button" class="btn btn-add" v-if="showServiceForm && !showEditeServiceForm && !showWatchServiceForm && !activeSpinner" @click="addNewService">Save</button>
        <button type="button" class="btn btn-add" v-if="showEditeServiceForm && !showWatchServiceForm && !activeSpinner" @click="updateService">Update</button>

        <div class="spinner-grow" role="status" v-if="activeSpinner">
            <span class="sr-only">Loading...</span>
        </div>

        <div class="servicesList">
            <div class="table-responsive">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Name</th>
                            <th scope="col">Size</th>
                            <th scope="col" style="width: 20%;">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(servicesData, index) in servicesData" :key="index">
                            <th scope="row">{{ index }}</th>
                            <!-- <td><img :src="api.img + '/' +servicesData.serviceIcon" alt="icone" /> </td> -->
                            <td>{{ servicesData.name }}</td>
                            <td>{{ (servicesData.catalogueSize / (1024 * 1024)).toFixed(2) }} MB</td>
                            <td>
                                <div class="icons">
                                    <img src="./../../../../src/assets/img/icons/publicIco/eye-open-svgrepo-com.svg" alt="eyes" @click="downloadPDF(servicesData)" />
                                    <img src="./../../../../src/assets/img/icons/publicIco/edit-svgrepo-com.svg" alt="edit" @click="getUpdateServiceData(servicesData, false)" />
                                    <img src="./../../../../src/assets/img/icons/publicIco/delete-remove-fill-svgrepo-com.svg" alt="delete" @click="deleteService(servicesData._id)" />
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import APIs from './../../../../config'
    export default {
        data(){
            return {
                showServiceForm: false,
                showEditeServiceForm: false,
                showWatchServiceForm: false,

                name: "",
                description: "",
                serviceIcon: null,

                servicesData: null,
                api: {
                    url: APIs.API_URL,
                    img: APIs.API_IMAGES,
                },

                get_token: localStorage.getItem('token'),
                user_id: localStorage.getItem('user_id'),

                serviceID: null,
                activeSpinner: false
            }
        },
        props : {
            cardInfo : Object
        },
        created() {
            console.log("prestation de service: ", this.cardInfo._id)
            this.getServices()
        },
        methods: {
            setImage(event){
                this.serviceIcon = event.target.files[0]
            },
            downloadPDF(data) {
                window.open('http://localhost:3001/' + data.cataloguePDF, '_blank');
            },
             addNewService() {
                this.activeSpinner = true

                const fd = new FormData()
                fd.append('name', this.name)
                fd.append('cataloguePDF', this.serviceIcon)
                fd.append('fromCardId', this.cardInfo._id)

                axios.post(`${APIs.API_URL}/card/cardCatalogue/${this.user_id}/${this.cardInfo._id}`, fd,{
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${this.get_token}`
                    }
                })
                .then(() => {
                    this.activeSpinner = false
                    this.$swal.fire({
                        position: 'top-end',
                        icon: 'success',
                        title: "Added",
                        showConfirmButton: false,
                        timer: 1500
                    });
                    this.resetForm()
                })
                .catch( (error) => {
                    this.activeSpinner = false
                    this.$swal.fire({
                        position: 'top-end',
                        icon: 'error',
                        title: error.response.data.error,
                        showConfirmButton: false,
                        timer: 1500
                    });
                });
            },
            getServices() {
                this.activeSpinner = true
                axios.get(`${APIs.API_URL}/card/cardCatalogue/${this.user_id}/${this.cardInfo._id}`, {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${this.get_token}`
                    }
                })
                .then(res => {
                    this.activeSpinner = false
                    this.servicesData = res.data
                })
            },
            resetForm() {
                this.getServices()
                this.name = ""
                this.serviceIcon = null
                this.showServiceForm = false
                this.showEditeServiceForm = false
                this.showWatchServiceForm = false
            },
            resetForm2() {
                this.getServices()
                this.name = ""
                this.serviceIcon = null
                this.showServiceForm = !this.showServiceForm
                this.showEditeServiceForm = false
                this.showWatchServiceForm = false
            },
            deleteService(serviceID) {
                this.$swal({
                    position: "center-center",
                    text: "Are you sure you want to delete ?",
                    icon: "warning",
                    showCancelButton: false,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Deleted",
                }).then((result) => {
                    if (result.isConfirmed) {
                        axios.delete(`${APIs.API_URL}/card/cardCatalogue/${this.user_id}/${serviceID}`, {
                            headers: {
                                'Content-Type': 'application/json',
                                Authorization: `Bearer ${this.get_token}`
                            }
                        })
                        .then(() => {
                            this.resetForm()
                        })
                    }
                });
            },
            async getUpdateServiceData(data, status) {
                this.activeSpinner = true

                const url = APIs.API_IMAGES + "/" + data.cataloguePDF
                const fileName = 'myFile.pdf'
                await fetch(url)
                .then(async response => {
                    const contentType = response.headers.get('content-type')
                    const blob = await response.blob()
                    const file = new File([blob], fileName, { contentType, type: "application/pdf" })
                    // access file here
                    this.serviceIcon = file
                    this.activeSpinner = false
                })

                console.log(this.serviceIcon)

                this.showServiceForm = true
                this.showEditeServiceForm = true

                this.name = data.name
                this.description = data.description
                this.serviceID = data._id

                this.showWatchServiceForm = status
            },
            updateService() {
                this.activeSpinner = true

                const fd = new FormData()
                fd.append('name', this.name)
                fd.append('cataloguePDF', this.serviceIcon)

                axios.put(`${APIs.API_URL}/card/cardCatalogue/${this.user_id}/${this.serviceID}/${this.cardInfo._id}`, fd,{
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${this.get_token}`
                    }
                })
                .then(() => {
                    this.activeSpinner = false

                    this.$swal.fire({
                        position: 'top-end',
                        icon: 'success',
                        title: "Updated",
                        showConfirmButton: false,
                        timer: 1500
                    });
                    this.resetForm()
                })
                .catch( (error) => {
                    this.activeSpinner = false

                    this.$swal.fire({
                        position: 'top-end',
                        icon: 'error',
                        title: error.response.data.error,
                        showConfirmButton: false,
                        timer: 1500
                    });
                });
            }
        }
    }
</script>

<style scoped lang="scss">
    .services {
        background-color: white;
        padding: 2% 6%;
        border-radius: 10px;
        margin: 0% 5%;
        .rowInputs {
            display: flex;
            justify-content: space-around;
            .form-group {
                width: 30%;
            }
        }
        .addSeviceBtn {
            display: flex;
            justify-content: flex-end;
        }
        .servicesList {
            table {
                tbody {
                    tr {
                        td {
                            .icons {
                                display: flex;
                                justify-content: space-around;
                                img {
                                    width: 30px;
                                    cursor: pointer;
                                }
                            }
                        }
                        img {
                            width: 50px;
                            height: 50px;
                            border-radius: 50%;
                        }
                    }
                }
            }
        }
    }
</style>
